import { render, staticRenderFns } from "./SkuSpecialTitle.vue?vue&type=template&id=a06a16e6&scoped=true&"
import script from "./SkuSpecialTitle.vue?vue&type=script&lang=ts&"
export * from "./SkuSpecialTitle.vue?vue&type=script&lang=ts&"
import style0 from "./SkuSpecialTitle.vue?vue&type=style&index=0&id=a06a16e6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a06a16e6",
  null
  
)

export default component.exports